import { ref, query, equalTo, orderByChild } from "firebase/database";
import { useContext, useEffect, useState } from "react";
import { useList, useListVals } from "react-firebase-hooks/database";

import { database } from 'lib/firebase'
import { useBroadcast } from "./useBroadcast";
import { useDbQuery } from "./useDbQuery";
import { DataContext } from "contexts/DataContext";

export const useGroup = ({user}) => {

  const { groups } = useContext(DataContext)
  const [groupItems, loadingGroup, errorGroup, refreshGroup] = groups;
  
  const [broadcasts, loadingBrd, errorBrd, refreshBrd] = useBroadcast({user})

  return [groupItems.map(gr => {
    if (gr.broadcastId) gr.broadcast = broadcasts.find(br => br.id === gr.broadcastId)
    return gr
  }), loadingGroup || loadingBrd, errorGroup || errorBrd, () => {
    refreshGroup()
    refreshBrd()
  }];
};
